import React, { useEffect, useRef, useState } from 'react'
import Tooltip from '@ublique/components/Tooltip'

import { noop } from 'lodash'

import './index.scss'

const NotificationTooltip = ({ notificationTooltip, t }) => {
  const [tooltipVisible, setTooltipVisible] = useState(false)
  const timebarRef = useRef()

  useEffect(() => {
    if (notificationTooltip) {
      setTooltipVisible(notificationTooltip)
    }
  }, [notificationTooltip])

  useEffect(() => {
    if (tooltipVisible) {
      timebarRef.current?.classList.toggle('tooltip-time-bar--animated')

      const to = setTimeout(() => {
        setTooltipVisible(false)
      }, 2000)

      return () => {
        clearTimeout(to)
      }
    }
  }, [tooltipVisible])

  return (
    <Tooltip
      className='notification-tooltip'
      direction='bottom'
      showIcon={false}
      menuOffset={{ top: 8, left: -25 }}
      open={tooltipVisible}
      onChange={noop}
    >
      <div ref={timebarRef} />
      <p>{t('NEW_NOTIFICATION')}</p>
    </Tooltip>
  )
}

export default NotificationTooltip
